module.exports = __webpack_public_path__ + "assets/bijiben.07fff7df.svg";